import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-home" }
const _hoisted_2 = { class: "group-title" }

import router from '@/router';

// 定义类型
type ParentList = {
  name: string;
  children: Array<{
    name: string;
    path: string;
  }>;
};

// 父级和子级结合的类型
type List = ParentList;

// 数据列表

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const routerList: List[] = [
  {
    name: '工单管理',
    children: [
      { name: '创建工单', path: 'createOrder' },
      { name: '预览工单', path: 'previewOrder' },
      { name: '工单详情', path: 'orderDetails' },
    ],
  },
  {
    name: '作业管理',
    children: [
      { name: '填写作业结果', path: 'worker' },
      { name: '填写质检结果', path: 'inspector' },
      { name: '填写并检查作业结果', path: 'leader' },
    ],
  },
  {
    name: '审批管理',
    children: [
      { name: '新建审批', path: 'selectAudit' },
      { name: '审批详情', path: 'auditDetails' },
      { name: '新增审批', path: 'createAudit' },
    ],
  },
  {
    name: '任务管理',
    children: [
      { name: '创建任务', path: 'createTask' },
      { name: '任务详情', path: 'taskDetails' },
    ],
  },
];

// 页面跳转方法
const goPage = (item: { name: string; path: string }) => {
  if (item.path) {
    router.push({ name: item.path });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routerList, (group, groupIndex) => {
      return _createElementVNode("div", {
        key: groupIndex,
        class: "group"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(group.name), 1),
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (child, childIndex) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: childIndex,
                title: child.name,
                clickable: "",
                onClick: ($event: any) => (goPage(child))
              }, {
                value: _withCtx(() => [
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    class: "icon-arrow"
                  })
                ]),
                _: 2
              }, 1032, ["title", "onClick"]))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ])
    }), 64))
  ]))
}
}

})